import React, { FC, useCallback, memo } from 'react';
import styled from 'styled-components';
import CheckboxListWithSearch from '@minecraft.checkbox-list-with-search';
import { useDrawerSearchFilterNameOrCategory } from '@minecraft.drawer';
import { FilterData } from '../../../shared/types';
import { Label } from '../../../shared/styles';
import { FiltersCategoryNameEnum } from '../../shared/types';

const StyledLabel = styled(Label)`
  margin-top: 1rem;
`;

type Props = FilterData;

const GenderAppearance: FC<Props> = ({ name, label }) => {
  const { getMatchedSearchOptions } = useDrawerSearchFilterNameOrCategory(FiltersCategoryNameEnum.genderAppearance);

  const renderFieldLabel = useCallback((fieldLabel: string): JSX.Element => {
    return <StyledLabel>{fieldLabel}</StyledLabel>;
  }, []);

  return (
    <>
      <Label>{label}</Label>
      <CheckboxListWithSearch
        withSelectAll
        withFormik
        name={name}
        options={getMatchedSearchOptions(name)}
        renderFieldLabel={renderFieldLabel}
      />
    </>
  );
};

export default memo(GenderAppearance);
